var React = require('react');

function ArrowPrev (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.1602 3.49268L5.65349 13.9993L16.1602 24.506L13.3335 27.3327L0.000152588 13.9993L13.3335 0.666016L16.1602 3.49268Z","fill":"#404040"}));
}

ArrowPrev.defaultProps = {"width":"17","height":"28","viewBox":"0 0 17 28","fill":"none"};

module.exports = ArrowPrev;

ArrowPrev.default = ArrowPrev;
